import { render, staticRenderFns } from "./DashboardAdminSekolah.vue?vue&type=template&id=b244d6a6&"
import script from "./DashboardAdminSekolah.vue?vue&type=script&lang=js&"
export * from "./DashboardAdminSekolah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports